import styled from 'styled-components';

import { colors } from '~/utils/css-mixins';
import media from '~/utils/media';

const Wrapper = styled.section`
  padding: 3px;
  background: ${colors.bgsiteSecondary};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 3px;
  margin-bottom: 30px;
  border: 1px solid ${colors.border};
  ${media.tablet`
    padding: 10px;
  `}
`;

const Filter = styled.button`
  cursor: pointer;
  color: ${props => (props.isSelected ? 'white' : 'black')};
  background: ${props => props.isSelected && `${colors.primary}`};
  border-radius: ${props => props.isSelected && `3px;`};
  box-shadow: ${props => props.isSelected && '1px 1px 2px 0 #b4b4b4'};
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  padding: 7px 0;

  &:nth-child(2) {
    border-left: ${props => !props.isSelected && '1px solid #DDDDDD'};
    border-right: ${props => !props.isSelected && '1px solid #DDDDDD'};
  }
`;

const filters = [
  {
    id: 'all',
    text: 'Live',
  },
  {
    id: 'questions',
    text: 'Frågor',
  },
  {
    id: 'info',
    text: 'Info',
  },
];

const LiveFilter = props => (
  <Wrapper>
    {filters.map(filter => (
      <Filter
        key={filter.id}
        onClick={() => {
          props.onClick(filter.id);
        }}
        isSelected={filter.id === props.selected}
      >
        {filter.text}
      </Filter>
    ))}
  </Wrapper>
);

export default LiveFilter;
